import HttpClient from '../../utils/HttpClient';

const httpClient = HttpClient.createInstance();

export const fetchMyAgreements = () => httpClient.get('/agreements/mine');

export const resendAgreement = (agreementId, toFullName, fullName, toPhoneNumber) =>
  httpClient.post('/agreements/resend', { agreementId, toFullName, fullName, toPhoneNumber });
